import React from 'react';
import Financial from '../images/finance.svg';
import { Link } from 'react-router-dom';
import { FaCloud, FaLock, FaMobileAlt, FaDesktop } from 'react-icons/fa';
import SubserviceDetailComponent from '../components/SubserviceDetailComponent';

const services = [
  {
    icon: <FaCloud />,
    title: 'Cash Flow Forecasting',
    description: 'Predict future cash flows to ensure adequate liquidity and financial stability.',
  },
  {
    icon: <FaLock />,
    title: 'Working Capital Management',
    description: 'Manage working capital efficiently to support day-to-day operations and growth.',
  },
  {
    icon: <FaMobileAlt />,
    title: 'Cash Management Solutions',
    description: 'Implement solutions to manage cash flow effectively, optimizing liquidity and reducing financial risks.',
  },
];


const CashFlow = () => {
  return (
    <div className = "relative">
      <img
        className="h-auto w-full object-cover"
        src={Financial}
        alt="Financial Services"
      />

      <div>

      <section className='text-left mt-6'>
      <h1 className="text-center my-6 text-2xl font-semibold">Cash Flow Management</h1>
      </section>
     

      <section>
        <SubserviceDetailComponent services={services}/>
        <div className='mb-6'>
      <h2 className="text-xl font-semibold mb-6 mx-6">Get Started with Expert Finance Services</h2>
      <p className="text-md text-black mb-6 px-12 text-left">
      Maximize efficiency, enhance security, and drive growth with our tailored Finance Services. Our certified experts provide 24/7 support, proactive monitoring, and strategic Finance planning to meet your business needs.
      </p>
      
      <Link to="/contact"
        className="inline-block bg-[#13689b] text-white py-3 px-6 rounded-md text-md font-semibold transition-transform transform hover:scale-105">
      Contact Us
      </Link>
      </div>
      </section>

    </div>

    </div>
  )
}

export default CashFlow
